<template>
  <div :class="$style.topbar">
    <div class="mr-4">
      <cui-fav-pages v-if="mode != 'production'" />
    </div>
    <div class="mr-4">
      <span>{{ timestamp }}</span>
    </div>
    <div class="mr-auto">
      <!-- <cui-search v-if="mode != 'production'" /> -->
    </div>
    <div class="mr-4 d-none d-md-block">
      <!-- <cui-issues-history v-if="mode != 'production'" /> -->
    </div>
    <div class="mb-0 mr-auto d-xl-block d-none">
      <!-- <cui-project-management v-if="mode != 'production'" /> -->
    </div>
    <div class="mr-4 d-none d-sm-block">
      <span>งบประมาณ พ.ศ.2563</span>
      <!-- <cui-language-switcher v-if="mode != 'production'" /> -->
    </div>
    <div class="mr-4 d-none d-sm-block">
      <cui-actions v-if="mode != 'production'" />
    </div>
    <div>
      <cui-user-menu />
    </div>
  </div>
</template>
<script>
// import CuiIssuesHistory from './IssuesHistory';
// import CuiProjectManagement from './ProjectManagement';
// import CuiSearch from './Search';
// import CuiLanguageSwitcher from './LanguageSwitcher';
import CuiActions from './Actions';
import CuiUserMenu from './UserMenu';
import CuiFavPages from './FavPages';
import moment from 'moment';
export default {
  components: {
    // CuiIssuesHistory,
    // CuiProjectManagement,
    // CuiSearch,
    // CuiLanguageSwitcher,
    CuiActions,
    CuiUserMenu,
    CuiFavPages,
  },
  data: function () {
    return {
      timestamp: '',
      mode: process.env.NODE_ENV,
    };
  },
  /* created() {
    setInterval(this.getNow, 1000);
  }, */
  mounted: function () {
    if (moment.locale() != 'th') moment.locale('th');
    this.getNow();
    setInterval(this.getNow, 1000);
  },
  methods: {
    getNow: function () {
      /* const today = new Date();
      const date =
        today.getDate() +
        '/' +
        (today.getMonth() + 1) +
        '/' +
        today.getFullYear();
      const time =
        today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
      const dateTime = date + ' ' + time;
      this.timestamp = dateTime; */
      this.timestamp = this.mtby(moment(), 'LLLL:ss');
    },
  },
};
</script>
<style lang="scss" module>
@import './style.module.scss';
</style>
